'use strict';

var typography = require('../../../../../../../../../../_virtual/typography.cjs');

var TYPOGRAPHY_TYPES = /*#__PURE__*/ function(TYPOGRAPHY_TYPES) {
    TYPOGRAPHY_TYPES["h1"] = "h1";
    TYPOGRAPHY_TYPES["h2"] = "h2";
    TYPOGRAPHY_TYPES["h3"] = "h3";
    TYPOGRAPHY_TYPES["h4"] = "h4";
    TYPOGRAPHY_TYPES["h5"] = "h5";
    TYPOGRAPHY_TYPES["body"] = "body";
    TYPOGRAPHY_TYPES["callout"] = "callout";
    TYPOGRAPHY_TYPES["footnote"] = "footnote";
    TYPOGRAPHY_TYPES["caption"] = "caption";
    TYPOGRAPHY_TYPES["subcaption"] = "subcaption";
    TYPOGRAPHY_TYPES["smallest"] = "smallest";
    return TYPOGRAPHY_TYPES;
}({});

typography.__exports.TYPOGRAPHY_TYPES = TYPOGRAPHY_TYPES;

module.exports = typography.__exports;
//# sourceMappingURL=typography.cjs.map
